import GamificationTooltip from './gamificationTooltip';

export default GamificationTooltip;
